import React from "react";

export default function Footer({ telegramUrl }) {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-[#040818] border-t border-white/5 py-12"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-8 items-start">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-full border border-[#d4af37]/50 flex items-center justify-center font-serif text-[#d4af37] text-lg">
                D
              </span>
              <span className="font-serif text-white text-lg">
                Derya Eliz Yıldız
              </span>
            </div>
            <p className="mt-4 text-[#94a3b8] text-sm font-light max-w-md leading-relaxed">
              Borsa, yatırım piyasaları ve hisse analizleri üzerine genel
              bilgilendirme içerikleri. Tüm paylaşımlar yatırım tavsiyesi
              niteliği taşımaz.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#d4af37] mb-4">
              Site Haritası
            </div>
            <ul className="space-y-2 text-sm text-[#cbd5e1] font-light">
              <li>
                <a href="#hakkinda" className="hover:text-[#d4af37] transition-colors" data-testid="footer-link-hakkinda">
                  Hakkında
                </a>
              </li>
              <li>
                <a href="#borsa-bilgilendirmeleri" className="hover:text-[#d4af37] transition-colors" data-testid="footer-link-borsa">
                  Borsa Bilgilendirmeleri
                </a>
              </li>
              <li>
                <a href="#telegram-vip" className="hover:text-[#d4af37] transition-colors" data-testid="footer-link-telegram">
                  Telegram VIP
                </a>
              </li>
              <li>
                <a href="#sss" className="hover:text-[#d4af37] transition-colors" data-testid="footer-link-sss">
                  S.S.S.
                </a>
              </li>
              <li>
                <a href="#iletisim" className="hover:text-[#d4af37] transition-colors" data-testid="footer-link-iletisim">
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#d4af37] mb-4">
              Takip Et
            </div>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/deryaelizyildiz/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:border-[#d4af37]/60 hover:text-[#d4af37] transition-colors"
                data-testid="footer-instagram"
              >
                <i className="fa-brands fa-instagram" />
              </a>
              <a
                href="https://x.com/deryaelizyildiz"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="X (Twitter)"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:border-[#d4af37]/60 hover:text-[#d4af37] transition-colors"
                data-testid="footer-twitter"
              >
                <i className="fa-brands fa-x-twitter" />
              </a>
              <a
                href="https://www.linkedin.com/in/derya-eliz-y%C4%B1ld%C4%B1z-ba70263b5/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-white hover:border-[#d4af37]/60 hover:text-[#d4af37] transition-colors"
                data-testid="footer-linkedin"
              >
                <i className="fa-brands fa-linkedin-in" />
              </a>
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Telegram"
                className="w-10 h-10 rounded-full border border-[#d4af37]/50 flex items-center justify-center text-[#d4af37] hover:bg-[#d4af37]/10 transition-colors"
                data-testid="footer-telegram"
              >
                <i className="fa-brands fa-telegram" />
              </a>
            </div>

            <p className="mt-6 text-[11px] text-[#64748b] leading-relaxed">
              Bu sitedeki içerikler genel bilgilendirme amaçlıdır.
              Yatırım tavsiyesi niteliği taşımaz.
            </p>
          </div>
        </div>

        <div className="gold-divider my-10" />

        <div className="flex flex-col md:flex-row justify-between gap-4 text-[12px] text-[#64748b]">
          <div data-testid="footer-copyright">
            © {year} Derya Eliz Yıldız. Tüm hakları saklıdır.
          </div>
          <div>
            deryaelizyildiz.vip
          </div>
        </div>
      </div>
    </footer>
  );
}
